import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import EngineerDelete from "@/view/pages/partials/Delete-Request-Template.vue";
import JobRequestMixin from "@/core/lib/job/api.request.job.mixin";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  mixins: [CommonMixin, JobRequestMixin],
  props: {
    detail: {
      required: true,
      type: Object,
      default: function _default() {
        return new Object();
      }
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    isVisitDetail: {
      type: Boolean,
      default: false
    },
    visitId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      engineerDeleteDialog: false,
      engineerDeleteRequestURL: "",
      dates: [],
      datePicker: false,
      job: 0,
      teams: [],
      visitList: [],
      filter: {
        search: null,
        visit: 0
      },
      timeout: null,
      timeoutLimit: 500,
      teamLoading: false
    };
  },
  components: {
    Barcode: Barcode,
    EngineerDelete: EngineerDelete
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler: function handler(param) {
        this.job = this.lodash.toSafeInteger(param.id);
      }
    }
  },
  methods: {
    deleteEngineerConfirm: function deleteEngineerConfirm(data) {
      var _this = this;

      _this.engineerDeleteRequestURL = "job/" + data.ticket + "/engineer/" + data.engineer.id;
      _this.engineerDeleteDialog = true;
    },
    engineerDeleteSuccess: function engineerDeleteSuccess() {
      this.engineerDeleteDialog = false;
      this.$emit("delete:engineer", true);
      this.getEngineerList();
    },
    getEngineerList: function getEngineerList() {
      var _this = this;

      var filter = {
        search: _this.filter.search,
        visit: _this.visitId,
        daterange: _this.dates
      };

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit("update:error", InitializeError("End Date must be after Start Date."));
          return false;
        }
      }

      clearTimeout(_this.timeout);
      _this.teamLoading = true;
      _this.timeout = setTimeout(function () {
        _this.getEngineers(_this.job, {
          filter: filter
        }).then(function (response) {
          _this.teams = response.rows;
        }).catch(function (error) {
          _this.logError(error);
        }).finally(function () {
          _this.teamLoading = false;
        });
      }, _this.timeoutLimit);
    },
    getVisitList: function getVisitList() {
      var _this = this;

      if (_this.isVisitDetail) {
        return false;
      }

      _this.getVisitsForFilter(_this.job).then(function (response) {
        _this.visitList = response;
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    engineerDisplayText: function engineerDisplayText(param) {
      var _this = this;

      var display_name = new Array();

      if (_this.lodash.isEmpty(param) === false && _this.lodash.isArray(param)) {
        for (var i = 0; i < param.length; i++) {
          if (_this.lodash.isEmpty(param[i].engineer) === false) {
            display_name.push(param[i].engineer.display_name);
          }
        }
      }

      if (_this.lodash.isEmpty(display_name)) {
        return "Not assigned yet.";
      } else {
        return "Assigned to " + display_name.join(", ");
      }
    },
    clearFilter: function clearFilter(field) {
      var _this = this;

      switch (field) {
        case "search":
          _this.filter.search = null;
          break;

        case "dates":
          _this.dates = [];
          break;
      }

      _this.getEngineerList();
    }
  },
  mounted: function mounted() {
    this.getEngineerList(); // this.getVisitList();
  }
};